import { inject, Pipe, PipeTransform } from '@angular/core';
import { Configuration } from '@tfagency/core/data-access';

@Pipe({
  name: 'authorImageUrl',
  standalone: true,
})
export class AuthorImageUrlPipe implements PipeTransform {
  private basePath = inject(Configuration).basePath;

  transform(authorImageUrl: string | null | undefined): string | null {
    if (!authorImageUrl) return null;
    return `${this.basePath}/Users/${authorImageUrl}/Image`;
  }
}
